import React from 'react';
import { Link } from 'react-router-dom';
import { HomeIcon, CalculatorIcon, TelescopeIcon as EnvelopeIcon, ArrowRight } from 'lucide-react';
import { APP_NAME } from './Logo';  // Import de la constante
import { useAuth } from '../contexts/AuthContext';
import { useUserProfile } from '../hooks/useUserProfile';

const Footer = () => {
  const { user } = useAuth();
  const { profile } = useUserProfile(user?.uid);

  const getDetailedEstimateLink = () => {
    if (!user) {
      return '/register';
    }
    if (profile?.credits && profile.credits > 0) {
      return '/estimation/nouvelle';
    }
    return '/credits/purchase';
  };

  return (
    <footer className="bg-gradient-primary text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4 flex items-center">
              <HomeIcon className="h-5 w-5 mr-2" />
              {APP_NAME}
            </h3>
            <p className="text-white/80">
              Estimation précise des coûts de rénovation pour vos projets immobiliers.
            </p>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4 flex items-center">
              <CalculatorIcon className="h-5 w-5 mr-2" />
              Liens rapides
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-white/80 hover:text-white transition-colors">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/quick-estimate" className="text-white/80 hover:text-white transition-colors">
                  Estimation rapide
                </Link>
              </li>
              <li>
                <Link 
                  to={getDetailedEstimateLink()} 
                  className="text-white/80 hover:text-white transition-colors flex items-center"
                >
                  Estimation détaillée
                  <ArrowRight className="h-4 w-4 ml-1" />
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4 flex items-center">
              <EnvelopeIcon className="h-5 w-5 mr-2" />
              Contact
            </h3>
            <p className="text-white/80 mb-4">
              Une question ? N'hésitez pas à nous contacter.
            </p>
            <Link 
              to="/contact" 
              className="inline-flex items-center text-white hover:text-white/90 transition-colors"
            >
              <EnvelopeIcon className="h-5 w-5 mr-2" />
              Formulaire de contact
            </Link>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-white/10 text-center">
          <p className="text-white/60">
            &copy; {new Date().getFullYear()} {APP_NAME}. Tous droits réservés.
            {' • '}
            <Link to="/mentions-legales" className="hover:text-white">
              Mentions légales
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;